export const commonStyleSheet = new CSSStyleSheet();
commonStyleSheet.replaceSync(`
    :host, * {
        box-sizing: border-box;
    }
`);
